const actionTypes = {
  SET_QR_ORDER: "SET_QR_ORDER",
  SET_POS_DISCOUNT_CODES: "SET_POS_DISCOUNT_CODES",
};
export default actionTypes;
